import http from "../lib/http";
import { getDeliveredOrderedProductsForReview } from "./orders";

/**
 * Response shapes (your backend):
 * GET  /api/customer/reviews                -> { message, data: Review[] }
 * POST /api/customer/reviews                -> { message, data: Review }
 * GET  /api/customer/reviews/all/{product}  -> { message, data: Review[] }
 */

export const getUserReviews = async () => {
  const res = await http.get("/api/customer/reviews");
  return res.data; // { message, data: [...] }
};

export const addReview = async (reviewData) => {
  const formData = new FormData();

  formData.append("product_id", String(reviewData.product_id));
  formData.append("order_id", String(reviewData.order_id));
  formData.append("rating", String(reviewData.rating));
  formData.append("comment", String(reviewData.comment || ""));

  if (
    Array.isArray(reviewData.review_images) &&
    reviewData.review_images.length > 0
  ) {
    reviewData.review_images.forEach((file) => {
      formData.append("review_image[]", file);
    });
  }

  const res = await http.post("/api/customer/reviews", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data; // { message, data: {...} }
};

export const getProductReviewsByOthers = async (productId) => {
  const res = await http.get(`/api/customer/reviews/all/${productId}`);
  return res.data; // { message, data: [...] }
};

/**
 * Get delivered products of logged-in user and attach their existing reviews
 */
export const getReviewableDeliveredProducts = async () => {
  try {
    const [products, userReviewsResponse] = await Promise.all([
      getDeliveredOrderedProductsForReview(),
      getUserReviews(),
    ]);

    const userReviews = Array.isArray(userReviewsResponse?.data)
      ? userReviewsResponse.data
      : Array.isArray(userReviewsResponse)
      ? userReviewsResponse
      : [];

    return products.map((product) => {
      const matchedReviews = userReviews.filter((review) => {
        const reviewProductId =
          review.product_id || review.product?.id || review.productId;
        const reviewOrderId =
          review.order_id || review.order?.id || review.orderId;

        return (
          String(reviewProductId) === String(product.id) &&
          String(reviewOrderId) === String(product.orderId)
        );
      });

      return {
        ...product,
        hasReview: matchedReviews.length > 0,
        reviews: matchedReviews,
        latestReview:
          matchedReviews.length > 0
            ? matchedReviews[matchedReviews.length - 1]
            : null,
      };
    });
  } catch (error) {
    console.error("Error fetching reviewable delivered products:", error);
    throw error;
  }
};